// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function defaultValue_setIsStickyHidden(_bool) {
  
}

var defaultValue = {
  isStickyHidden: false,
  setIsStickyHidden: defaultValue_setIsStickyHidden
};

var context = React.createContext(defaultValue);

function useStickyVisibilityContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useStickyVisibilityContext ,
}
/* context Not a pure module */
